import ServiceLeftMenu from '../ServiceLeftMenu';
import SettingLeftMenu from '../Setting';
import {useLocation} from 'react-router-dom';
import {useEffect} from 'react';

const getChannelNavigationType = (pathname: string) => {
  const regexHome = /\/station\/([^\/]+)\/?$/;
  const regexService =
    /\/station\/([^\/]+)\/(board|post|guest|vod|catch|catchstory|sooptore|calendar)(\/[^\/]+)*\/?$/;
  const regexSetting = /\/station\/([^\/]+)\/(setting)(\/.*)?$/;

  return {
    isHome: !!pathname.match(regexHome),
    isServicePage: !!pathname.match(regexService),
    isSettingPage: !!pathname.match(regexSetting),
  };
};

/**
 * 방송국(방송국)에서만 사용하는 LeftMenu 조합 래퍼
 */
const ChannelLeftMenuWrapper = () => {
  const location = useLocation();
  const {isHome, isServicePage, isSettingPage} = getChannelNavigationType(
    location.pathname,
  );

  // 250811@gt : useLocationChangedHandler 한곳에서 처리
  /*useEffect(() => {
    globalNavigation.setLayoutVisibility('SNB', false);
  }, [location.pathname]);*/

  return (
    <>
      {(isHome || isServicePage) && <ServiceLeftMenu />}
      {isSettingPage && <SettingLeftMenu />}
    </>
  );
};

export default ChannelLeftMenuWrapper;
